import React, { useState, useEffect } from 'react';
import './FormCheckBoxGroup.css'
// FormCheckBoxGroup Component
interface FormCheckBoxGroupProps {
  id: string;
  label: string;
  options: string[];
  defaultSelected: string[];
  onSelectedChange: (selected: string) => void;
  onHandleChange: () => void,
  isValueChangeState?: boolean
}

const FormCheckBoxGroup: React.FC<FormCheckBoxGroupProps> = ({ id, label, options, defaultSelected, onSelectedChange, onHandleChange, isValueChangeState=false }) => {
  const [selected, setSelected] = useState(defaultSelected);

  useEffect(() => {
    let statusArray: string[] = [];
    if (selected.includes("未完")) {
      statusArray = [...statusArray, "0", "1", "2", "3"];
    }
    if (selected.includes("完了")) {
      statusArray = [...statusArray, "4"];
    }
    const mappedStatus = statusArray.join(',');
    onSelectedChange(mappedStatus);
  }, [selected, onSelectedChange]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSelected(prevState =>
      prevState.includes(value) ? prevState.filter(item => item !== value) : [...prevState, value]
    );
    onHandleChange();
  };

  return (
    <>
      <label className="formcheckboxgrouplabel">{label}</label>
      <div className="checkbox-group">
        {options.map((option, index) => (
          <>
            <input id={id + index} type="checkbox" value={option}
            className="formcheckbox-none"
              checked={selected.includes(option)}
              onChange={handleChange}
            />
            <label htmlFor={id + index} key={index} 
              className={isValueChangeState ? "formcheckbox value-change-state" : "formcheckbox"}
            >
              {option}
            </label>
          </>
        ))}
      </div>
    </>
  );
};

export default FormCheckBoxGroup;